export default {
  articles: [],
  article: {},
  categories: [],
  locations: [],
  subjects: [],
  levels: [],
  pagination: {}
};
